module.exports = __webpack_public_path__ + "bae0a776b590b4e1b6e8e119d5502b1d.png";